module.exports = __webpack_public_path__ + "img/appAsset--pos-ax.83b483d3.svg";